import { render, staticRenderFns } from "./RefundAppointment.vue?vue&type=template&id=536ac6a8"
import script from "./RefundAppointment.vue?vue&type=script&lang=js"
export * from "./RefundAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports